import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FboHttpClient } from 'src/app/shared/flight-log-api/fbos/fbo-client.service';
import { FboEntity } from 'src/store/fbo/fbo.model';
import { filterNull } from 'src/util/rxjs/operators';
import { SelectItem, toSelectionList, toSelectItem } from 'src/util/ui/forms';

interface Fbo extends FboEntity {
  displayName: string;
}

@Component({
  selector: 'fl-fbo-fuel-tank-autocomplete',
  templateUrl: './fbo-fuel-tank-autocomplete.component.html',
  styleUrls: ['./fbo-fuel-tank-autocomplete.component.scss'],
})
export class FboFuelTankAutocompleteComponent implements OnInit, OnDestroy {
  @Input()
  public fboId: UntypedFormControl;
  public initialSelectedItem$: Observable<SelectItem>;

  public options$: Observable<SelectItem[]>;
  public searches$ = new Subject<string>();
  public componentDestruction$ = new Subject<void>();

  constructor(private _fbos: FboHttpClient) {}

  public ngOnInit() {
    if (this.fboId.value !== null && this.fboId.value !== '') {
      this.initialSelectedItem$ = this._fbos.getById(this.fboId.value).pipe(
        filterNull(),
        map((fbo) => this.toFbo(fbo)),
        map(toSelectItem<Fbo>('displayName', 'id')),
      );
    }

    this.options$ = this.searches$.pipe(
      switchMap((searchTerm) => {
        return this._fbos.getAll({ $top: 100, searchTerm }).pipe(
          map((fbos) => fbos.map((fbo) => this.toFbo(fbo))),
          map(toSelectionList<Fbo>('displayName', 'id')),
        );
      }),
    );
  }

  public ngOnDestroy() {
    this.componentDestruction$.next();
  }

  public onSearch(searchTerm: string) {
    return this.searches$.next(searchTerm);
  }

  public toFbo(fbo: FboEntity): Fbo {
    return {
      ...fbo,
      displayName:
        fbo.airport != null && fbo.airport.faa != null
          ? `${fbo.name} (${fbo.airport.faa})`
          : `${fbo.name}`,
    };
  }

  public formatNameLabel(item: SelectItem) {
    return `${item.label}`;
  }
}
